'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'link-horizontal';
var width = 576;
var height = 512;
var aliases = ["chain-horizontal"];
var unicode = 'e1cb';
var svgPathData = 'M288 288c53 0 96-43 96-96s-43-96-96-96L160 96c-53 0-96 43-96 96 0 25.2 9.7 48.2 25.6 65.3-6.2 19.8-9.6 40.9-9.6 62.7 0 3.6 .1 7.2 .3 10.8-48-27.6-80.3-79.4-80.3-138.8 0-88.4 71.6-160 160-160l128 0c88.4 0 160 71.6 160 160S376.4 352 288 352l-16 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0zm16-128c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0c-53 0-96 43-96 96s43 96 96 96l128 0c53 0 96-43 96-96 0-25.2-9.7-48.2-25.6-65.3 6.2-19.8 9.6-40.9 9.6-62.7 0-3.6-.1-7.2-.3-10.8 48 27.6 80.3 79.4 80.3 138.8 0 88.4-71.6 160-160 160l-128 0c-88.4 0-160-71.6-160-160s71.6-160 160-160l16 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLinkHorizontal = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;